import { DISCLAIMER, FOOTER } from '../data/content'

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-in container">
        <p className="footer-legal">{FOOTER.legal}</p>
        <div className="footer-links">
          <a href={FOOTER.privacyHref}>{FOOTER.privacy}</a>
          <a href={FOOTER.termsHref}>{FOOTER.terms}</a>
        </div>
        <p className="footer-disclaimer">{DISCLAIMER}</p>
      </div>
    </footer>
  )
}
